/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';
import styles from './icon.less';

import { TestId } from '@trello/webdriverio-tests';
import 'fonts/trellicons.eot';
import 'fonts/trellicons.ttf';
import 'fonts/trellicons.woff';

export enum IconColor {
  Blue = 'blue',
  Gray = 'gray',
  Green = 'green',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Light = 'light',
  Dark = 'dark',
  Yellow = 'yellow',
}

export enum IconName {
  Activity = 'activity',
  AddMember = 'add-member',
  Add = 'add',
  Admin = 'admin-chevron',
  Archive = 'archive',
  Attachment = 'attachment',
  Back = 'back',
  Board = 'board',
  BusinessClass = 'business-class',
  Calendar = 'calendar',
  Camera = 'camera',
  CardCover = 'card-cover',
  Card = 'card',
  Check = 'check',
  CheckboxChecked = 'checkbox-checked',
  Checklist = 'checklist',
  Clock = 'clock',
  Close = 'close',
  Collection = 'collection',
  Comment = 'comment',
  Description = 'description',
  Down = 'down',
  Download = 'download',
  DropdownMenu = 'dropdown-menu',
  Edit = 'edit',
  Email = 'email',
  Emoji = 'emoji',
  ExternalLink = 'external-link',
  Facebook = 'facebook',
  Filter = 'filter',
  Fogbugz = 'fogbugz',
  Forward = 'forward',
  Gear = 'gear',
  Google = 'google',
  Heart = 'heart',
  House = 'house',
  Information = 'information',
  Instagram = 'instagram',
  Label = 'label',
  LeaveBoard = 'leave-board',
  List = 'list',
  Member = 'member',
  Mention = 'mention',
  Move = 'move',
  Microphone = 'microphone',
  Notification = 'notification',
  OrganizationVisible = 'organization-visible',
  Organization = 'organization',
  OverflowMenuHorizontal = 'overflow-menu-horizontal',
  PowerUp = 'power-up',
  Private = 'private',
  Public = 'public',
  Refresh = 'refresh',
  Remove = 'remove',
  Search = 'search',
  Share = 'share',
  Star = 'star',
  Sticker = 'sticker',
  Subscribe = 'subscribe',
  TrelloGold = 'trello-gold',
  Twitter = 'twitter',
  Up = 'up',
  Vote = 'vote',
  Warning = 'warning',
  Enterprise = 'enterprise',
  // custom, these are all svg and not icon fonts
  RemoveMember = 'remove-member',
  Copy = 'copy',
}

export interface IconProps {
  large?: boolean;
  small?: boolean;
  name: IconName;
  color?: IconColor;
  className?: string;
  custom?: boolean;
  testId?: TestId;
}

const Icon = (props: IconProps) => {
  const { large, small, custom, testId, ...rest } = props;

  const className = classNames(
    styles.icon,
    large && styles['icon-lg'],
    small && styles['icon-sm'],
    custom && styles['icon-custom'],
    styles[`icon-${props.name}`],
    props.color ? styles[`icon-${props.color}`] : null,
    props.className,
  );

  return (
    <span
      {...rest}
      className={className}
      data-test-id={testId}
      role="presentation"
    />
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./app/common/components/controls/icon/index.tsx